module.exports = __webpack_public_path__ + "static/media/zvonekBW.2705d848.jpg";